<template>
  <div class="md-card md-card-testimonial">
    <div class="md-card-header icon">
      <i class="material-icons">
        <slot name="header-icon"></slot>
      </i>
    </div>

    <div class="md-card-content">
      <slot name="content"></slot>
    </div>

    <div class="md-card-actions" style="justify-content: flex-start;">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "testimonial-card",
};
</script>
